export default __webpack_public_path__ + "b3a74c285a0e120c85bd942eacaa06c7.png";